import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Connect to emulators in development
if (import.meta.env.VITE_USE_EMULATORS === "true") {
  const authHost = import.meta.env.VITE_EMULATOR_AUTH_HOST || "localhost:9099";
  const firestoreHost = import.meta.env.VITE_EMULATOR_FIRESTORE_HOST || "localhost:8080";
  const functionsHost = import.meta.env.VITE_EMULATOR_FUNCTIONS_HOST || "localhost:5001";

  const [authHostname, authPort] = authHost.split(":");
  const [firestoreHostname, firestorePort] = firestoreHost.split(":");
  const [functionsHostname, functionsPort] = functionsHost.split(":");

  connectAuthEmulator(auth, `http://${authHostname}:${authPort}`);
  connectFirestoreEmulator(db, firestoreHostname, parseInt(firestorePort));
  connectFunctionsEmulator(functions, functionsHostname, parseInt(functionsPort));

  console.log("Connected to Firebase emulators");
}

export default app;
